var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "warning icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-warning-pop-up-without-saving-ticket-info",
    transform: "translate(-598.000000, -244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-8",
    transform: "translate(390.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning-icon",
    transform: "translate(208.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    fill: "#E9F5FE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    stroke: "#279CF7",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 42.5,
    cy: 42.5,
    r: 41.5
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-13",
    points: "33.0424805 43.8525391 43.0351563 57.0224609 53.3481445 43.8525391"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44,46 L41,46 L41,34 L44,34 L44,46 Z M44,53 L41,53 L41,50 L44,50 L44,53 Z",
    id: "\\uEB8E-copy",
    fill: "#2B9EF7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.153501,21.4752129 C42.8900702,21.2585749 43.7092839,21.3229286 44.4365564,21.7196227 C44.9422559,21.9954588 45.3578506,22.4110534 45.6336867,22.916753 L45.6336867,22.916753 L62.895518,54.5634436 C63.2922121,55.2907161 63.3565657,56.1099298 63.1399277,56.846499 C62.9232898,57.5830681 62.4256601,58.2369926 61.6983876,58.6336867 C61.2577218,58.8740499 60.7637882,59 60.2618312,59 L60.2618312,59 L25.7381688,59 C24.9097416,59 24.1597416,58.6642136 23.6168484,58.1213203 C23.0739552,57.5784271 22.7381688,56.8284271 22.7381688,56 C22.7381688,55.498043 22.8641189,55.0041094 23.104482,54.5634436 L23.104482,54.5634436 L40.3663133,22.916753 C40.7630074,22.1894805 41.4169319,21.6918509 42.153501,21.4752129 Z",
    id: "Triangle",
    stroke: "#279CF7",
    strokeWidth: 2,
    fillOpacity: 0,
    fill: "#D8D8D8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.35811c692e75c865de394694aa640547.svg";
export { ForwardRef as ReactComponent };